<template>
  <tr>
    <td>
      <v-btn
      icon
      text
      @click.stop="$emit('checkRow', item)">
        <v-icon :color="selected[item.id] ? 'color1' : ''"> 
          {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
      </v-btn>
      {{ item.name }}
    </td>
    <td></td>
  </tr>
</template>

<script>
export default {
  props: ['item', 'selected']
}
</script>